import { useEffect, useState } from 'react';
import api from '../api/client';

export function useSEO() {
  const [seoData, setSeoData] = useState<any>(null);

  useEffect(() => {
    api.get('/seo-manager/settings')
      .then(res => {
        const data = res.data;
        setSeoData(data);
        if (data.title) document.title = data.title;
        
        if (data.description) {
          let metaDesc = document.querySelector('meta[name="description"]');
          if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
          }
          metaDesc.setAttribute('content', data.description);
        }
      })
      .catch(console.error);
  }, []);

  return seoData;
}
